import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
export function WhatInsideSection() {
  const items = [{
    title: 'Fundamentos Faceless',
    desc: 'cómo crear autoridad sin mostrar tu cara'
  }, {
    title: 'Estética "lujo silencioso"',
    desc: 'cómo construir un feed que se siente premium'
  }, {
    title: 'Guía de contenido faceless',
    desc: 'ideas concretas para publicar sin bloquearte'
  }, {
    title: 'Copy que conecta',
    desc: 'estructuras simples para escribir sin sonar "vendedora"'
  }, {
    title: 'Monetización',
    desc: 'formas realistas de transformar atención en ventas (sin humo)'
  }];
  return <section id="incluye" className="py-10 bg-alt" data-id="element-282">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="text-center mb-12" data-id="element-284">
          <h2 className="text-3xl md:text-4xl font-serif text-title" data-id="element-285">
            Qué incluye el pack
          </h2>
        </div>

        <div className="bg-card p-8 md:p-12 border border-[#D9D0C1] shadow-sm" data-id="element-286">
          <ul className="space-y-6 mb-10" data-id="element-287">
            {items.map((item, index) => <li key={index} className="flex items-start" data-id="element-288">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-alt flex items-center justify-center mt-0.5 mr-4 border border-[#D9D0C1]" data-id="element-289">
                  <Check size={14} className="text-accent" data-id="element-290" />
                </div>
                <div data-id="element-291">
                  <span className="font-semibold text-title" data-id="element-292">
                    {item.title}:
                  </span>{' '}
                  <span className="text-body" data-id="element-293">{item.desc}</span>
                </div>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-294">
            <Button variant="primary" size="lg" withArrow data-id="element-295">
              Acceder al pack
            </Button>
            <p className="text-xs text-body mt-3" data-id="element-296">
              Pago único · Acceso inmediato · Garantía 14 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}